// Settings configured here will be merged into the final config object.

/* rating values
Strongly agree – stimme voll und ganz zu
Agree – stimme grösstenteils zu
Tend to agree – stimme teilweise zu
Neither agree nor disagree – weder noch
Tend to disagree – stimme teilweise nicht zu
Disagree – stimme grösstenteils nicht zu
Strongly disagree – stimme überhaupt nicht zu
 */

import { Axis } from 'types/Axis'
import { IAnswer } from 'types/IAnswer'
import { LinkedChainNavigation } from '../components/linkedChainNavigation/linkedChainNavigation'
import responseList from './responses.yml'
import values from './values.yml'
import { range } from 'd3-array'

/** Responses and their values */
const responses: [string, number][] = []
const revertedResponses: [string, number][] = []

responseList.forEach((response: string, index: number) => {
  responses.push([response, values[index]])
  revertedResponses.push([response, values[values.length - 1 - index]])
})

/** Database endpoint */
const dbEndpoint = 'https://empoerung-quiz-2020.firebaseio.com'

/** The domain for the Y axis (populism) */
export const domainY: [number, number] = [15, -15]

/** The domain for the X axis (conservatism) */
export const domainX: [number, number] = [-15, 15]

export const rangeX = range(domainX[0], domainX[1] + 1)
export const rangeY = range(domainY[0], domainY[1] - 1, -1)

/**
 * Calculate the total score for a desired axis from the collected answersReducer.
 * @param {IAnswer[]} answers
 * @param {'conservatism'|'populism'} axis
 */
function getScoreFor(answers: IAnswer[], axis: Axis): number {
  return answers
    .filter(answer => answer.axis === axis)
    .reduce(
      (previousValue: number, currentValue: IAnswer) =>
        previousValue + currentValue.answer,
      0
    )
}

export default {
  LinkedChainNavigation,
  dbEndpoint,
  domainX,
  rangeX,
  domainY,
  rangeY,
  getScoreFor,
  responses,
  revertedResponses
}
